type AddGroupFields = {
  groupSequence: string;
  chainName: string;
  groupName: string;
  groupType: string;
  assetName: string;
  maximumAmountLimit: string;
  rotateAmountLimit: string;
  unlimitAmount: boolean;
};

const initAddGroupFields: AddGroupFields = {
  groupSequence: "",
  chainName: "",
  groupName: "",
  groupType: "",
  assetName: "",
  maximumAmountLimit: "",
  rotateAmountLimit: "",
  unlimitAmount: false,
};

export { type AddGroupFields, initAddGroupFields };
